/* =============================================================
   INDUSTRIES SECTION — Show specific industries served
   Addresses: Original was vague "diverse clients across numerous industries"
   Design: Compact tag cloud + dashboard image
   ============================================================= */

import { ArrowRight } from "lucide-react";

const DASHBOARD_IMAGE = "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/xero-dashboard-QSjciByNNnp25ZRPUPtLJa.webp";

const industries = [
  "Trades & Construction",
  "Retail & E-commerce",
  "Hospitality & Cafés",
  "Health & Wellness",
  "Professional Services",
  "Media & Events",
  "Real Estate",
  "Childcare & Education",
  "Beauty & Personal Care",
  "Fitness & Sport",
  "Consulting",
  "Technology Startups",
];

export default function IndustriesSection() {
  return (
    <section className="py-20 lg:py-28 bg-[oklch(0.22_0.06_250)]">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div>
            <div className="section-label mb-4">Industries We Serve</div>
            <h2 className="text-3xl lg:text-4xl xl:text-5xl text-white mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className="block">Whatever Your Industry</span>
              <span className="block italic text-[oklch(0.72_0.12_75)]">We Know Your Numbers</span>
            </h2>
            <p className="text-white/60 text-lg mb-8 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}>
              We've worked with Perth businesses across virtually every industry. Each comes with its own bookkeeping challenges — and we know them all.
            </p>

            {/* Industry tags */}
            <div className="flex flex-wrap gap-2.5 mb-8">
              {industries.map((industry) => (
                <span
                  key={industry}
                  className="px-3.5 py-1.5 rounded-full text-sm border border-white/20 text-white/70 hover:border-[oklch(0.72_0.12_75)/0.6] hover:text-[oklch(0.72_0.12_75)] transition-colors cursor-default"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {industry}
                </span>
              ))}
            </div>

            <a href="#contact" className="btn-gold">
              Get Industry-Specific Advice
              <ArrowRight size={16} />
            </a>
          </div>

          {/* Right: Dashboard image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/40" style={{ aspectRatio: '16/10' }}>
              <img
                src={DASHBOARD_IMAGE}
                alt="Xero bookkeeping dashboard showing financial reports"
                className="w-full h-full object-cover"
                loading="lazy"
                width={460}
                height={287}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[oklch(0.22_0.06_250)/0.3] to-transparent rounded-2xl" />
            </div>
            {/* Floating badge */}
            <div className="absolute -top-5 -right-4 lg:-right-6 bg-[oklch(0.72_0.12_75)] text-[oklch(0.15_0.04_250)] rounded-xl px-4 py-3 shadow-xl">
              <div className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Xero</div>
              <div className="text-xs font-semibold" style={{ fontFamily: "'DM Mono', monospace" }}>CERTIFIED ADVISOR</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
